/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/styles/makeStyles';
import {
    string, bool,
} from 'prop-types';
import { useSelector } from 'react-redux';
import { getProfileInfo } from '../../../../state/ducks/App/ducks/Common/Common-Selectors';
import triggerPopChatEvent from '../../MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';
import { getOperatingSystem } from '../../../../state/ducks/App/ducks/Config/Config-Helpers';
import { getCurrentBrandId, getFeatureFlags } from '../../../pages/Account/utils/featureSelectors';

const styles = (theme) => ({
    root: {
        padding: '5px 10px',
    },
    title: {
        fontSize: '2.1em',
    },
    link: {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: '15px',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.text.primary,
    },
    reloadButon: {
        display: 'block',
        margin: '32px auto',
        textTransform: 'capitalize',
    },
});

const useStyles = makeStyles(styles);

const PageErrorBoundary = ({ errorMessage, showReload }) => {
    const classes = useStyles();
    const operatingSystem = getOperatingSystem().toLowerCase();
    const currentBrand = useSelector((state) => getCurrentBrandId(state));
    const featureFlags = useSelector((state) => getFeatureFlags(state));
    const customerData = useSelector((state) => state?.member);
    const profile = useSelector(getProfileInfo);
    const userData = {
        firstName: profile?.firstName || '',
        lastName: profile?.lastName || '',
        email: profile?.email || '',
    };

    return (
        <div className={classes.root}>
            <Typography paragraph className={classes.title} align="center" variant="h4">
                {errorMessage}
            </Typography>
            <Typography paragraph className={classes.body} align="center" variant="body1">
                If you continue experiencing problems,
                <button
                    type="button"
                    className={classes.link}
                    tabIndex={0}
                    onClick={() => triggerPopChatEvent(userData, operatingSystem, currentBrand, featureFlags, customerData)}
                ><span>click&nbsp;here</span>
                </button>
                to chat now
            </Typography>

            {showReload && (
                <Button
                    className={classes.reloadButon}
                    onClick={() => {
                        if (typeof window !== 'undefined') {
                            window.location.reload();
                        }
                    }}
                    variant="contained"
                    color="primary"
                >
                    Try Again
                </Button>
            )}
        </div>
    );
};

PageErrorBoundary.propTypes = {
    errorMessage: string.isRequired,
    showReload: bool.isRequired,
};

export default PageErrorBoundary;
